import React from "react";
import "./WhyChooseUs.css";

const features = [
  {
    title: "Fast Brand Launch",
    text: "Find your domain, connect your website, and start your online presence without complex setup.",
    icon: "🚀",
  },
  {
    title: "Budget-Friendly Plans",
    text: "Simple pricing made for new businesses, freelancers, creators, and startup projects.",
    icon: "💸",
  },
  {
    title: "Safe Domain Control",
    text: "Manage DNS, renewals, SSL, and account settings with a cleaner secure dashboard.",
    icon: "🛡️",
  },
  {
    title: "All-in-One Platform",
    text: "Domains, hosting, email, security, and business tools in one place for easy management.",
    icon: "⚙️",
  },
];

const WhyChooseUs = () => {
  return (
    <section className="why-section">
      <div className="why-container">
        <div className="why-heading">
          <span>Why DoHostingPay</span>
          <h2>Everything your online brand needs</h2>
          <p>
            A simple platform built to help businesses launch faster, stay
            secure, and manage their digital identity with confidence.
          </p>
        </div>

        <div className="why-grid">
          {features.map((item) => (
            <article className="why-card" key={item.title}>
              <div className="why-icon" aria-hidden="true">
                {item.icon}
              </div>
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;